import { useCallback } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { addBenefit, updateBenefit } from 'services/benefit-type-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { required as required, WhiteStyledField, Title, ErrorMsg } from 'libs/form';
import { StyledButtonContainer } from './benefit-type-form.styled';
import { notify } from 'libs/common';

const checkFn = (t) => (value) => {
  if (value) {
    return value.length === 16 ? undefined : t('messages.В номере должно быть 16 символов');
  } else {
    return t('validation.Обязательное поле');
  }
};

const BenefitTypeForm = (props) => {
  const { error, destroy, refresh, setMessage, form, handleSubmit, close, type } = props;

  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const requiredT = useCallback(required(t), [t]);
  const checkFnT = useCallback(checkFn(t), [t]);

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage(t('grid.Изменения сохранены'));
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const out = { ...values };
    const method = isAdd ? addBenefit : updateBenefit;

    return method(out)
      .then(() => {
        afterSubmit();
        return true;
      })
      .catch((error) => {
        notify('Скидки', error.toString());
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Новая скидка') : t('form.Скидка') + ' ' + props.initialValues?.name;

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />

        <WhiteStyledField validate={requiredT} placeholder={t('form.Клиент')} type="text" label={t('form.Клиент')} name="name" autoFocus />
        <WhiteStyledField validate={checkFnT} placeholder={t('form.Номер ФН')} type="text" label={t('form.Номер ФН')} name="fn" maxLength={16} />
        <WhiteStyledField validate={requiredT} placeholder={t('grid.Минимальная сумма')} type="text" label={t('grid.Минимальная сумма')} name="min_amount" naturalNumber />
        <WhiteStyledField validate={requiredT} placeholder={t('grid.Сумма скидки')} type="text" label={t('grid.Сумма скидки')} name="amount" naturalNumber />

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue} type="submit">
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'benefitTypeForm',
  // destroyOnUnmount: false,
})(BenefitTypeForm);
